import api from 'lib/Api'

const exportTypes = {
  event: args => api.post('/event_log_exports', args),
  graph: args => api.get(`/graph_processes/${args.graphId}/export`, args),
}
export default exportTypes
